// TODO: remove the @ts-nocheck
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  Typography,
  Button,
  IconButton,
  Card,
  CardMedia,
  Grow,
  TextField,
  Chip,
  Icon,
  Divider,
  Grid,
  Dialog,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from 'mui-datatables';
import { ConfirmDialog, CustomToolbarSelect } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {
  cancelPromotionAPI,
  reschedulePromotionAPI,
  getPromotionsAPI,
} from 'api';
import clsx from 'clsx';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { useHistory} from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import MarkdownIt from 'markdown-it';
import noImage from 'components/Logo/no-image.png';
import logo from 'components/Logo/logo-dermpro.svg';
import { discount_unit } from '../../utils';


const md = new MarkdownIt();


const useStyles = makeStyles(() => ({
  textPrimary: {
    color: '#001239',
  },
  cardimage: {
    objectFit: 'cover',
    height: '200px',
  },
  cardBackground: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    lineHeight: '200px',
    color: '#555',
    border: '1px solid #eaeaea',
    fontSize: '24px',
    height: '200px',
    marginBottom: '10px',
  },
  divider: {
    background: 'rgba(200, 200, 200, 0.3)',
    marginBottom: '15px',
  },
  datesRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dateInput: {
    margin: 10
  },
  startButton: {
    margin: '20px 10px 10px 10px'
  },
  labelsFilter: {
    minWidth: 400,
  },
}));

const promoStatusNames = {
  'Started': 'Started',
  'Published': 'Scheduled',
  'Finished': 'Complete',
  'New': 'New',
  'Failed': 'Failed'
};

const Promos = ({promoStatus, tabName}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const {loadingCanceledPromoList, promoData = {}, metadata = {}} = useSelector((state: IReduxState) => (state.promo));
  const [filter, setFilter] = useState({page: '1', limit: '20', name: '', status: promoStatus, sorting: 'desc', labelsIds: ''});

  const [searchValue, setSearchValue] = useState('');
  const [selectedPromo, setSelectedPromo] = useState<IPromotion | IEmptyPromo>({});
  const [promoToCancel, setPromoToCancel] = useState<IPromotion | IEmptyPromo>({});

  const promosFilter = promoData[promoStatus]?.config || [];
  const promosList = promoData[promoStatus]?.promotions || [];

  const labelOptions = Object.entries(metadata)?.reduce((acc, [, labels]) => {
    acc = [...acc, ...labels as []];
    return acc;
  }, []);

  useEffect(() => {
    getPromotionsAPI({dispatch, ...filter});
  }, [filter]);

  const handleCancelPromo = () => {
    cancelPromotionAPI({dispatch, id: promoToCancel._id});
  };

  const handleReschedulePromo = (id, startDate, endDate) => {
    reschedulePromotionAPI({dispatch, id, startDate, endDate});
    setSelectedPromo({});
  };

  const handleFilterSubmit = (filterList) => {
    const labelsIds = filterList[6]?.map((label) => label._id);
    setFilter((filter) => ({...filter, labelsIds}));
  };

  const columns = [
    {
      name: 'banner',
      label: 'Banner',
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const item = promosList[dataIndex];

          return (
            <div className="flex items-center max-w-250 w-full">
              <img
                src={(item.slider.bannerImageInfo?.imageS3) ? item.slider.bannerImageInfo?.imageS3 : noImage}
                alt={item.promoName}
                className="w-full cursor-pointer"
                onError={(e) => {
                  (e.target as HTMLImageElement).onerror = null;
                  (e.target as HTMLImageElement).src = noImage;
                }}
                onClick={() => history.push({
                  pathname: `/my-promotions/${tabName}/promo-details/${item._id}`,
                  state: { promo: item }
                })}
              />
            </div>
          );
        }
      },
    },
    {
      name: 'promoName', // field name in the row object
      label: 'Promotion Title', // column title that will be shown in table
      options: {
        sort: false,
        filter: false,
        setCellHeaderProps: () => ({ style: { width: '25%'}}),
        customBodyRenderLite: (dataIndex) => {
          const {promoName} = promosList[dataIndex];
          return <span>{promoName}</span>;
        }
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRenderLite: (dataIndex) => {
          const item = promosList[dataIndex];
          return (
            <div className="flex items-center">
              <p className="my-0 text-15" >{promoStatusNames[item.status]}</p>
            </div>
          );
        },
      },
    },
    {
      name: 'startDate',
      label: 'Start Date',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'endDate',
      label: 'End Date',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'action',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({ style: { width: '15%'}, className: 'text-14'}),
        customBodyRenderLite: (dataIndex) => {
          const item = promosList[dataIndex] || {};
          const isLoadingPromo = !!loadingCanceledPromoList.find((el) => el === item._id);

          return (
            isLoadingPromo ?
              <CircularProgress size={25} />
              :
              <div className="flex items-center">
                {promoStatus === 'Started' &&
                <IconButton
                  title="Cancel"
                  onClick={() => setPromoToCancel(item)}
                >
                  <Icon className="text-gray">cancel</Icon>
                </IconButton>
                }
                {promoStatus === 'Published' &&
                <>
                  <IconButton
                    title="Reschedule"
                    onClick={() => setSelectedPromo(item)}
                  >
                    <Icon className="text-gray">schedule</Icon>
                  </IconButton>
                  <IconButton
                    title="Cancel"
                    onClick={() => setPromoToCancel(item)}
                  >
                    <Icon className="text-gray">cancel</Icon>
                  </IconButton>
                </>
                }
                {promoStatus === 'Finished' &&
                <IconButton
                  title="Report"
                  onClick={() => setSelectedPromo(item)}
                >
                  <Icon className="text-gray">equalizer</Icon>
                </IconButton>
                }
                <IconButton
                  title="Details"
                  onClick={() => history.push({
                    pathname: `/my-promotions/${tabName}/promo-details/${item._id}`,
                    state: { promo: item }
                  })}
                >
                  <Icon className="text-gray">info</Icon>
                </IconButton>
              </div>
          );
        },
      },
    },
    {
      name: 'labels',
      label: 'Labels',
      options: {
        filter: true,
        display: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const item = promosList[dataIndex];
          const uniqueLabels = [...new Set(item.labels.map((item) => item.label))].join(', ') || '';
          return (
            <div className="flex items-center">
              <p className="my-0 text-15" >{uniqueLabels}</p>
            </div>
          );
        },
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            if (v[0] === '') {
              v = [];
            }

            return `${v[0].type}: ${v[0].label}`;
          },
          update: (filterList, _filterPos, index) => {
            filterList[index] = [];
            setFilter((filter) => ({...filter, labelsIds: ''}));
            return filterList;
          }
        },
        filterOptions: {
          fullWidth: true,
          display: (filterList, onChange, index, column) => {
            return (
              <Autocomplete
                // displayEmpty
                className={classes.labelsFilter}
                value={labelOptions.find((label) => filter.labelsIds.includes(label._id)) || ''}
                options={labelOptions}
                getOptionLabel={(option) => option?.label || ''}
                groupBy={(option) => option?.type}
                onChange={(_, value, action) => {
                  if (action === 'clear') {
                    filterList[index] = [];
                    onChange(filterList[index], index, column);
                    setFilter((filter) => ({...filter, labelsIds: ''}));
                  } else if (action === 'select-option') {
                    filterList[index] = [value];
                    onChange(filterList[index], index, column);
                    setFilter((filter) => ({...filter, labelsIds: value._id}));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="Labels"
                    label="Labels"
                  />
                )}
              />
            );
          }
        }
      }
    },
  ];

  return (
    <div className={clsx(classes.textPrimary)}>
      <Card className="pb-7">
        <MUIDataTable
          data={promosList}
          columns={columns}
          options={{
            filterArrayFullMatch: false,
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none', // set checkbox for each row
            search: true, // set search option
            filter: true, // set data filter option
            download: false, // set download option
            print: false, // set print option
            pagination: true, //set pagination option
            viewColumns: true, // set column option
            elevation: 0,
            textLabels: {
              body: {
                noMatch:
                (
                  <Button
                    className="uppercase custom-check-all custom-check-all-select mr-2"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      history.push({
                        pathname: '/my-promotions/library',
                      });
                    }}
                  >
                    Search from my Library
                  </Button>
                )
              }
            },
            searchPlaceholder: 'Enter product name',
            searchOpen: Boolean(searchValue),
            onFilterChange: (column, filterList, type) => {
              if (['chip', 'reset'].includes(type)) {
                handleFilterSubmit(filterList);
              }
            },
            customToolbarSelect: (selectedRows) => (
              <CustomToolbarSelect selectedRows={selectedRows} productList={{}} />
            ),
            customSearchRender: (
              searchText,
              handleSearch,
              hideSearch
            ) => {
              return (
                <Grow appear in timeout={300}>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={searchValue}
                    onChange={({ target: { value } }) =>
                      setSearchValue(value)
                    }
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                        setFilter((f) => ({...f, name: searchValue}));
                      }
                    }}
                    InputProps={{
                      style: {
                        paddingRight: 0,
                      },
                      startAdornment: (
                        <Icon
                          className="mr-2"
                          fontSize="small"
                        >
                          search
                        </Icon>
                      ),
                      endAdornment: (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setFilter((f) => ({...f, name: ''}));
                            hideSearch();
                          }}
                        >
                          <Icon fontSize="small">
                            clear
                          </Icon>
                        </IconButton>
                      ),
                    }}
                  />
                </Grow>
              );
            },
            onTableChange: (action, state) => {
              if (action === 'propsUpdate') {
                state.selectedRows = {
                  data: [],
                  lookup: {},
                };
              }
            },
            rowsPerPage: filter.limit,
            page: Number(filter.page) - 1,
            rowsPerPageOptions: [10, 20, 40, 80, 100],
            serverSide: true,
            count: promosFilter.totalCount,
            onChangePage: (currentPage) => setFilter((f) => ({...f, page: String(Number(currentPage) + 1)})),
            onChangeRowsPerPage: (newLimit) => setFilter((f) => ({...f, limit: String(newLimit), page: '1'}))
          }}
        />
      </Card>

      <Dialog
        open={selectedPromo._id && promoStatus === 'Finished'}
        onClose={() => setSelectedPromo({})}
        maxWidth="md"
      >
        <Grid item md={12} sm={4} xs={6} key={selectedPromo._id}>
          <Card elevation={25} className="p-8">
            <h2>{selectedPromo.promoName} <Chip className="ml-4" color="primary" label={promoStatusNames[selectedPromo.status]} /></h2>
            <Divider className={classes.divider} />
            <div>Products: {selectedPromo.skus?.map((item) => <Chip variant="outlined" label={item?.name} key={item.sku} />)}
            </div>
            <p>Sales Rules: {selectedPromo.salesRules?.map((item) => <Chip variant="outlined" label={item.ruleName} key={item.ruleName} />)}</p>
            <p>Categories: {selectedPromo.categories?.map((item) => <Chip variant="outlined" label={item.name} key={item.id} />)}</p>
            {selectedPromo.categoryForAssign && <p>Category for assign: {selectedPromo.categoryForAssign.name}</p>}
            <p>Start date: {selectedPromo.startDate}</p>
            <p>End date: {selectedPromo.endDate}</p>
            <p>Product description: <div dangerouslySetInnerHTML={{ __html: md.render(selectedPromo.promoDescription || '') }} /></p>
            <p>Category description: {selectedPromo.categoryDescription}</p>
            <Divider className={classes.divider} />
            <p>Results:</p>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell align="right">Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedPromo.skus?.map((product) => {
                    return (
                      <TableRow
                        key={product.id}
                        // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {product.name}
                        </TableCell>
                        <TableCell align="right">{product.price}</TableCell>
                      </TableRow>
                    );
                  }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              color="primary"
              variant="contained"
              className={classes.startButton}
              onClick={() => setSelectedPromo({})}
            >
              Close
            </Button>
          </Card>
        </Grid>
      </Dialog>

      <Dialog
        open={selectedPromo._id && promoStatus === 'Published'}
        onClose={() => setSelectedPromo({})}
        fullWidth
        maxWidth={'md'}
      >
        <Grid item md={12} sm={4} xs={6} key={selectedPromo._id}>
          <Card elevation={25} className="p-5">
            <Grid item md={12} sm={6} xs={12}>
              {selectedPromo.slider?.bannerImageInfo ?
                <CardMedia
                  component="img"
                  className={classes.cardimage}
                  height="140"
                  alt="Image not found"
                  image={selectedPromo.slider?.bannerImageInfo?.imageS3}
                  title={selectedPromo.promoName}
                /> :
                <CardMedia image={logo} title={selectedPromo.promoName}>
                  <div className={classes.cardBackground} />
                </CardMedia>
              }
            </Grid>
            <Grid item md={12} sm={6} xs={12}>
              {selectedPromo.promoType?.typeName &&
              <Typography variant="body2" color="textSecondary" component="p" title={selectedPromo.promoDescription}>
                <span className="font-semibold">Type: </span>
                {selectedPromo.promoType?.typeName}
                {selectedPromo.salesRules[0] && <p>Discount: {selectedPromo.salesRules[0]?.discountAmount} {discount_unit[selectedPromo.salesRules[0]?.discountType]}</p>}
              </Typography>
              }
              {selectedPromo.skus?.map((product) => {
                return (
                  <Typography key={product.sku} color="textSecondary" component="p">
                    {product.name}
                  </Typography>
                );
              })}
            </Grid>

            <Grid item xs={12} className={classes.datesRow}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  className={classes.dateInput}
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="startDate"
                  label="Start date"
                  autoOk
                  disablePast
                  value={selectedPromo.startDate}
                  onChange={(e) => setSelectedPromo((promo) => ({...promo, startDate: format(e, 'MM/dd/yyyy')}))}
                />
                <DatePicker
                  className={classes.dateInput}
                  error={Date.parse(selectedPromo.endDate) < Date.parse(selectedPromo.startDate)}
                  helperText={Date.parse(selectedPromo.endDate) < Date.parse(selectedPromo.startDate) && 'End Date cant be less than Start Date'}
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="endDate"
                  label="End date"
                  autoOk
                  disablePast
                  value={selectedPromo.endDate}
                  onChange={(e) => setSelectedPromo((promo) => ({...promo, endDate: format(e, 'MM/dd/yyyy')}))}
                />
              </MuiPickersUtilsProvider>
              <Grid item md={4} sm={6} xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.startButton}
                  disabled={Date.parse(selectedPromo.startDate) > Date.parse(selectedPromo.endDate)}
                  onClick={() => {
                    handleReschedulePromo(selectedPromo._id, selectedPromo.startDate, selectedPromo.endDate);
                  }}
                >
                  Save
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.startButton}
                  onClick={() => setSelectedPromo({})}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Dialog>

      <ConfirmDialog
        title="Cancel Promotion?"
        open={Boolean(promoToCancel._id)}
        setOpen={() => setPromoToCancel({})}
        onConfirm={handleCancelPromo}
      >
        Are you sure you want to cancel this promotion?
      </ConfirmDialog>
    </div>
  );
};

export default Promos;
